// noinspection DuplicatedCode

$ = require('jquery/dist/jquery');

window.$ = window.jQuery = global.$ = global.jQuery = $;

try {
    window.Popper = require('popper.js').default;
    require('bootstrap');
} catch (e) {
}

let moment = require('moment');
window.moment = moment;

require('datatables.net-bs4');
require('datatables.net-buttons');
require('datatables.net-buttons-bs4');
require('datatables.net-select-bs4');
// require('datatables.net-buttons/js/buttons.colVis');
// require('datatables.net-buttons/js/buttons.flash');
// require('datatables.net-buttons/js/buttons.html5');
// require('datatables.net-buttons/js/buttons.print');
require('datatables.net-colreorder-bs4');
// require('datatables.net-fixedcolumns-bs4');
// require('datatables.net-fixedheader-bs4');
require('datatables.net-keytable-bs4');
require('datatables.net-responsive-bs4');
require('datatables.net-rowgroup-bs4');
// require('datatables.net-rowreorder-bs4');
require('datatables.net-scroller-bs4');
require('datatables.net-searchbuilder-bs4');
require('datatables.net-searchpanes-bs4');
require('datatables.net-datetime');

require('daterangepicker');

let csrfToken;

$(document).ready(function () {
    replaceAllEmailHrefs();
    csrfToken = $('meta[name="csrf-token"]').attr('content');

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': csrfToken
        }
    });
});

// helper function to log errors
function logError(error) {
    if (typeof console !== 'undefined') {
        'error' in console ? console.error(error) : console.log(error);
    }
}

// Fetch unscrambled email by id and replace href in the provided anchor element
function replaceEmail(anchorElement) {
    const contactUuid = anchorElement.getAttribute('data-contactid');
    if (contactUuid) {
        $.ajax({
            url: '/contact/unscramble',
            type: 'POST',
            data: {uuid: contactUuid},
            beforeSend: function (xhr) {   // Include the CSRF token in the header
                xhr.setRequestHeader("X-CSRF-TOKEN", csrfToken);
            },
            success: function (response) {
                const unscrambledEmail = response.email;
                anchorElement.href = `mailto:${unscrambledEmail}`;
                anchorElement.textContent = `${unscrambledEmail}`;
            },
            error: function (error) {
                logError(error);
            }
        });
    }
}

// Loop through all the anchor with 'data-contactid' attribute on the website
function replaceAllEmailHrefs() {
    const anchorElements = document.querySelectorAll("a[data-contactid]");
    for (let i = 0; i < anchorElements.length; i++) {
        replaceEmail(anchorElements[i]);
    }
}
